import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAssignments: builder.query({
            query: () => `/assignments`,
        }),

        getAssignment: builder.query({
            query: (id) => `/assignments?id=${id}`,
        }),

        getAssignmentByVideo: builder.query({
            query: (videoId) => `/assignments?video_id=${videoId}`,
        }),

        addAssignment: builder.mutation({
            query: (data) => ({
                url: "/assignments",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getAssignments", undefined, draft => {
                                draft.push(res?.data)
                            })
                        )
                    }
                } catch (err) {

                }
            },
        }),

        editAssignment: builder.mutation({
            query: ({ id, data }) => ({
                url: `/assignments/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getAssignments", undefined, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );

                        dispatch(
                            apiSlice.util.updateQueryData("getAssignment", arg.id, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );


                    }
                } catch (err) {

                }
            },
        }),

        deleteAssignment: builder.mutation({
            query: (id) => ({
                url: `/assignments/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getAssignments", undefined, (draft) => {
                            return draft.filter(a => a.id != arg)
                        })
                    )
                } catch (err) {

                }
            },
        }),
    }),
});

export const {
    useGetAssignmentQuery,
    useDeleteAssignmentMutation,
    useGetAssignmentsQuery,
    useAddAssignmentMutation,
    useGetAssignmentByVideoQuery,
    useEditAssignmentMutation
} = assignmentsApi;
